import { render } from "./QRCodeReader.vue?vue&type=template&id=83fbf49a"
import script from "./QRCodeReader.vue?vue&type=script&lang=js"
export * from "./QRCodeReader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__